// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseStaleCluster
 */
export interface ResponseStaleCluster {
  /**
   *
   * @type {string}
   * @memberof ResponseStaleCluster
   */
  clusterName?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseStaleCluster
   */
  lastError?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseStaleCluster
   */
  lastErrorAt?: string;
}

/**
 * Check if a given object implements the ResponseStaleCluster interface.
 */
export function instanceOfResponseStaleCluster(
  value: object,
): value is ResponseStaleCluster {
  return true;
}

export function ResponseStaleClusterFromJSON(json: any): ResponseStaleCluster {
  return ResponseStaleClusterFromJSONTyped(json, false);
}

export function ResponseStaleClusterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseStaleCluster {
  if (json == null) {
    return json;
  }
  return {
    clusterName: json['clusterName'] == null ? undefined : json['clusterName'],
    lastError: json['lastError'] == null ? undefined : json['lastError'],
    lastErrorAt: json['lastErrorAt'] == null ? undefined : json['lastErrorAt'],
  };
}

export function ResponseStaleClusterToJSON(json: any): ResponseStaleCluster {
  return ResponseStaleClusterToJSONTyped(json, false);
}

export function ResponseStaleClusterToJSONTyped(
  value?: ResponseStaleCluster | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusterName: value['clusterName'],
    lastError: value['lastError'],
    lastErrorAt: value['lastErrorAt'],
  };
}
